<div
    *ngFor="
        let alert of alerts$ | async | slice: 0 : MAX_VISIBLE;
        trackBy: trackByAlertId
    "
    [@flyInOut]
>
    <q-alert-view
        [alert]="alert"
        (onAlertClose)="handleAlertClosed($event)"
    ></q-alert-view>
</div>
<div
    class="float-end badge bg-secondary dark-shadow-sm"
    *ngIf="((alerts$ | async)?.length ?? 0) > MAX_VISIBLE"
>
    Showing {{ MAX_VISIBLE }} of {{ (alerts$ | async)?.length }} ...
</div>
